import CounselorCompetences from './components/CounselorCompetences.vue';
import CounselorPaymentForm from './components/CounselorPaymentForm.vue';
import CounselorContactForm from './components/CounselorContactForm.vue';
import MeetingTypesAndAddress from './components/MeetingTypesAndAddress.vue';
import MeetingTypeIcons from './components/MeetingTypeIcons.vue';
import InitComponent from 'Modules/InitComponent';
import store from 'Stores/store';

// Counselor Competences
const counselorCompetences = document.querySelectorAll(
  '.vue-counselor-competences'
);
const initCounselorCompetencesComponent = new InitComponent({
  selectors: counselorCompetences,
  components: { CounselorCompetences },
  template: '<CounselorCompetences />',
  store,
});

initCounselorCompetencesComponent.init();

// Counselor Payment Form
const singleCouncelorPayment = document.getElementById(
  'vue-counselor-payment-form'
);
const initSingleCouncelorPaymentComponent = new InitComponent({
  selectors: singleCouncelorPayment,
  components: { CounselorPaymentForm },
  template: '<CounselorPaymentForm />',
  store,
});

initSingleCouncelorPaymentComponent.init();

// Counselor Contact Form
const singleCouncelorContactForm = document.getElementById(
  'vue-counselor-contact-form'
);
const initSingleCouncelorContactFormComponent = new InitComponent({
  selectors: singleCouncelorContactForm,
  components: { CounselorContactForm },
  template: '<CounselorContactForm />',
  store,
});

initSingleCouncelorContactFormComponent.init();

// Meeting Types and Address
const meetingTypesAndAddress = document.querySelectorAll(
  '.vue-counselor-top-section-meeting-types-and-address'
);

meetingTypesAndAddress.forEach((meetingTypesAndAddress) => {
  const { role } = meetingTypesAndAddress.dataset;

  const initMeetingTypesAndAddressComponent = new InitComponent({
    selectors: meetingTypesAndAddress,
    components: { MeetingTypesAndAddress },
    template: '<MeetingTypesAndAddress />',
    store,
    data: {
      role,
    },
  });

  initMeetingTypesAndAddressComponent.init();
});

// Meeting Type Icons
const meetingTypeIcons = document.querySelectorAll(
  '.vue-counselor-top-section-meeting-type-icons'
);

meetingTypeIcons.forEach((meetingTypeIcon) => {
  const { role } = meetingTypeIcon.dataset;

  const initMeetingTypeIconsComponent = new InitComponent({
    selectors: meetingTypeIcon,
    components: { MeetingTypeIcons },
    template: '<MeetingTypeIcons />',
    store,
    data: {
      role,
    },
  });

  initMeetingTypeIconsComponent.init();
});
